(ns ycweb.components.grid
  (:require
   [rum.core :as rum]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.datepicker :as datepicker]
   [ycweb.util.core :as yuc]
   [ycweb.components.forms :as forms]
   [ycweb.components.toaster :as toaster]))

(defn modal-cursor
  [app-atom]
  (rum/cursor app-atom :modal))

(defmulti modal-config (fn [app-atom config-atom tp] tp))
(defmulti action (fn [app-atom config action-key] action-key))

(rum/defc section < rum/static [& body]
  (into [:div.section] body))

(rum/defc row < rum/static [{:keys [flush? pull-lr?]} & body]
  (into [:div {:class (yuc/bem :flex-grid-group [(when flush? :flush) (when pull-lr? :flush-force)])}] body))

;; Only supports cols in #{1 2 3 4} at the moment.
(rum/defc cell < rum/static [{:keys [span cols flush?]} & body]
  (let [c
        (if (= span cols)
          :full
          (keyword (str span "-" cols)))]
    [:div {:class (yuc/bem :flex-grid-block [c (when flush? :flush)])}
     (into
       [:div.flex-grid-content]
       body)]))

(rum/defc tabular-list [data-collection]
  [:ul.tabular-list
   (for [{:keys [icon-modifiers value] :as r} data-collection]
     [:li.tabular-list__item
      [:span.tabular-list__item-icon-wrapper
       [:i {:class (yuc/bem :icon (vec (concat [:block :3-3] icon-modifiers)))}]]
      [:span.tabular-list__item-name (when (:name r) (:name r))]
      [:span.tabular-list__item-value [:b (when value value)]]])])

(rum/defc secondary-foot-note [{:keys [secondary-fn secondary-text secondary-custom]}]
  [:p.call-to-action__alt-action
   (or secondary-custom
     (when secondary-text
       (if secondary-fn
         (buttons/button secondary-text
           secondary-fn
           {:text-default true})
         secondary-text)))])

(rum/defc button-row < rum/static
  [{:keys [single-type single-options single-text single-fn single-style single-icon-left single-icon-right single-plain disabled
           left-type left-options left-text left-fn left-style left-icon left-no-icon left-plain
           right-type right-options right-text right-fn right-style right-icon right-icon-placement-left right-no-icon right-plain right-disabled?]}]
  (if
    (or single-text single-fn)
    (row {:flush? true}
      (cell {:span 1 :cols 1 :flush? true}
        (buttons/button (or single-text "Done")
          single-fn
          {:square-corners true :large true :full true :text-default (and (not single-fn) single-plain)
           :primary (when (= single-style :primary) true)
           :secondary (when (or (= single-style :secondary) (and (not single-fn) single-plain)) true)
           :call-to-action (when (or (= single-style :call-to-action) (= single-style nil)) true)
           :negative (when (= single-style :negative) true)
           :disabled (or disabled (and (not single-plain) (nil? single-fn)))
           :icon-left single-icon-left
           :icon-right single-icon-right
           :icon-class (when (or single-icon-left single-icon-right) (if (= single-style :secondary) :2-1 :2-2))})))
    (row {:flush? true}
      (cell {:span 1 :cols 2 :flush? true}
        (let [left-btn-text
              (cond
                left-text
                left-text

                (and (= left-text nil) left-fn)
                "Back")]
          (cond
            (= left-type :web)
            (buttons/button-web
              left-btn-text
              (merge
                {:square-corners true
                 :style (if left-style left-style :secondary-noborder)
                 :size :large
                 :full true
                 :text-default (and (not left-fn) left-plain)
                 :icon
                 (when
                   (and (not left-no-icon) (or left-text left-fn))
                   (cond
                     left-icon
                     left-icon

                     (not left-plain)
                     :arrow-left))}
                left-options))

            :else
            (buttons/button
              left-btn-text
              left-fn
              {:square-corners true :large true :full true :text-default (and (not left-fn) left-plain)
               :primary (when (= left-style :primary) true)
               :secondary (when (or (= left-style :secondary) (= left-style nil) (and (not left-fn) left-plain)) true)
               :call-to-action (when (= left-style :call-to-action) true)
               :negative (when (= left-style :negative) true)
               :icon-left (when (and (not left-no-icon) (or left-text left-fn)) (cond left-icon left-icon (not left-plain) :arrow-left))}))))
      (cell {:span 1 :cols 2 :flush? true}
        (let [right-btn-text
              (cond
                right-text
                right-text

                (and (= right-text nil) right-fn)
                "Next")]
          (cond
            (= right-type :web)
            (buttons/button-web
              right-btn-text
              (merge
                {:square-corners true
                 :style (if right-style right-style :primary)
                 :size :large
                 :full true
                 :text-default (and (not right-fn) right-plain)
                 :icon
                 (when
                   (and (not right-no-icon) (or right-text right-fn))
                   (cond
                     right-icon
                     right-icon

                     (not right-plain)
                     :arrow-right))
                 :icon-placement (if (and right-icon-placement-left right-icon) :left :right)}
                right-options))

            :else
            (buttons/button
              right-btn-text
              right-fn
              {:square-corners true :large true :full true :text-default (and (not right-fn) right-plain)
               :primary (when (or (= right-style :primary) (= right-style nil)) true)
               :secondary (when (or (= right-style :secondary) (and (not right-fn) right-plain)) true)
               :call-to-action (when (= right-style :call-to-action) true)
               :negative (when (= right-style :negative) true)
               :disabled (or right-disabled? (and (not right-plain) (nil? right-fn)))
               :icon-right (when (and (not (or right-no-icon right-icon-placement-left)) (or right-text right-fn)) (cond right-icon right-icon (not right-plain) :arrow-right))
               :icon-left (when (and right-icon-placement-left right-icon) right-icon)})))))))

(rum/defc pos-call-to-action < rum/static [config]
  [:div.call-to-action
   (button-row config)])

(declare close-modal)

(defn dispatch-modal-action [app-atom action-key & [config {:keys [prevent-closing]}]]
  (let [modal-atom (modal-cursor app-atom)]

    (when-not prevent-closing
      (close-modal app-atom))

    (action app-atom (merge config (:config @modal-atom)) action-key)))

(defn dispatch-action [app-atom action-key config]
  (println "Dispatching action: " action-key)
  (action app-atom config action-key))

(rum/defc modal < rum/reactive cmn/cursors
  [app-atom context-modal?]
  (let [modal-atom (modal-cursor app-atom)
        open (cmn/curact modal-atom [:open])

        {:keys [cancel-key] :as modal-state}
        (cmn/curact-keys modal-atom ::modal [:cancel-key :type])

        {:keys [overlay? max-width form? size error? warning? success? editor-style] :as modal-atom-config}
        (cmn/curact-keys (cmn/cursor-in modal-atom [:config :config]) ::modal
          [:max-width :size :overlay? :form? :error? :warning? :success? :type :editor-style])

        ;; message-modal / confirm-modal pass config flat at [:config]; demo-style
        ;; callers nest at [:config :config]. Merge both so status flags reach here
        ;; regardless of caller convention.
        status-config
        (merge
          (select-keys modal-atom-config [:type :error? :warning? :success?])
          (cmn/curact-keys (cmn/cursor-in modal-atom [:config]) ::modal-status
            [:type :error? :warning? :success?]))

        {:keys [body header body-raw footer modal-type content-type requires-action close-action?] :as m-config}
        (when (:type modal-state)
          (modal-config app-atom (rum/cursor modal-atom :config) (:type modal-state)))

        current-target? ((if context-modal? = not=) modal-type :context-menu)
        cancel-key
        (or cancel-key (:cancel-key m-config))
        max-width (or max-width (:max-width m-config))]

    (into
      (if (:form? modal-atom-config)
        [:form
         {:id :modal-wrapper
          :tabIndex -1
          :class
          (remove nil?
            (concat
              [(when max-width (str "u-max-width-" max-width))]
              (yuc/bem :modal
                [(when footer :has-footer)
                 (when (and current-target? open) :is-open)
                 (if context-modal?
                   :context-menu
                   modal-type)
                 (when-not (= (:size modal-atom-config) :default) (:size modal-atom-config))
                 (when (or (:error? status-config) (= :error (:type status-config))) :is-error)
                 (when (or (:warning? status-config) (= :warning (:type status-config))) :is-warning)
                 (when (or (:success? status-config) (= :success (:type status-config))) :is-success)])))}]
        [:div
         {:id :modal-wrapper
          :tabIndex -1
          :class
          (remove nil?
            (concat
              [(when max-width (str "u-max-width-" max-width))]
              (yuc/bem :modal
                [(when footer :has-footer)
                 (when (and current-target? open) :is-open)
                 (if context-modal?
                   :context-menu
                   modal-type)
                 (when-not (= (:size modal-atom-config) :default) (:size modal-atom-config))
                 (when (or (:error? status-config) (= :error (:type status-config))) :is-error)
                 (when (or (:warning? status-config) (= :warning (:type status-config))) :is-warning)
                 (when (or (:success? status-config) (= :success (:type status-config))) :is-success)])))}])

      (list
        (when header
          [:div {:class (yuc/bem :modal__header)}
           [:h2 {:class (yuc/bem :modal__heading :yc-heading [:default :flush])}
            header]])
        (when body-raw
          (body-raw app-atom (rum/cursor modal-atom :config) m-config))
        (when (and body current-target?)
          [:div
           (yuc/maybe assoc
             {:class (yuc/bem :modal__content [content-type])}
             :style editor-style)
           (body app-atom (rum/cursor modal-atom :config) m-config)])
        (when (and footer current-target?)
          [:div.modal__footer (footer app-atom (rum/cursor modal-atom :config) m-config)])

        (when open
          (when-not (and requires-action current-target?)
            [:a.modal__close-button
             {:id :last-tab
              :href "#"
              :on-click
              (cond
                (and close-action? cancel-key)
                #(do
                   (.preventDefault %)
                   (dispatch-action app-atom cancel-key {})
                   (close-modal app-atom))

                cancel-key
                #(do
                   (.preventDefault %)
                   (dispatch-modal-action app-atom cancel-key))

                :else
                #(do
                   (.preventDefault %)
                   (close-modal app-atom)))}
             [:i {:class (yuc/bem :icon [:4-1 :close :block])}]]))

        (when overlay?
          (toaster/loading-overlay app-atom :modal/modal-loading))))))

(rum/defc modal-background < rum/reactive
  [app-atom]
  (let [{:keys [opening config]} (rum/react (modal-cursor app-atom))]
    [:div
     {:class
      (yuc/bem :modal-overlay
        [(when opening :is-open)
         (when (get-in config [:config :blur-bg?]) :blur-bg)
         (when (:background-type config) (:background-type config))])}]))

(defn update-modal-config [app-atom modal-key config]
  (let  [modal-atom (modal-cursor app-atom)
         modal-data @modal-atom
         open? (and (= modal-key (:type modal-data)) (:open modal-data))]
    (when open?
      (swap! modal-atom update :config
        (fn [cfg]
          (merge cfg config))))))

(defn open-modal [app-atom modal-type & [config]]
  (let  [modal-atom (modal-cursor app-atom)
         open? (:open @modal-atom)]
    (println "Opening modal: " modal-type)
    (reset! modal-atom
      {:opening true
      ;; When opening modal SSR, no animation.
       :open #?(:cljs open? :clj true)
       :type modal-type :config config})
    #?(:cljs
       (let [body (.-body js/document)]
         (.add (.-classList body) "body--no-scroll")))
    (when-not open?
      #?(:cljs
         (.setTimeout js/window
           #(let [prior-focus (.-activeElement js/document)
                  modal-wrapper (.getElementById js/document "modal-wrapper")]
              (swap! modal-atom assoc
                :open true
                :prior-element prior-focus)
              (when modal-wrapper
                (.focus modal-wrapper)))
           25)
         :clj nil))
    nil))

(defn close-modal [app-atom]
  (let [modal-atom (modal-cursor app-atom)
        modal-uuid (yuc/rand-uuid)]
    (swap! modal-atom assoc :open false :opening false :uuid modal-uuid)

    #?(:cljs
       (let [body (.-body js/document)
             prior-element (:prior-element @modal-atom)]
         (.remove (.-classList body) "body--no-scroll")
         (.setTimeout js/window
           (fn []
             (when (= modal-uuid (:uuid @modal-atom))
               ;; Clear :type first so the modal body unmounts and its
               ;; rum/reactive watchers detach before we wipe :config.
               (swap! modal-atom dissoc :type)
               ;; Defer the full reset to the next tick so React has
               ;; processed the unmount by the time :config changes.
               (.setTimeout js/window
                 (fn []
                   (when (= modal-uuid (:uuid @modal-atom))
                     (reset! modal-atom {:open false :opening false})))
                 0)
               (when prior-element (.focus prior-element))))
           200)))))

(defmethod action :default [app-atom action-key])

(defn closing-modal
  "Return a function that will close the modal and call a given function, if supplied"
  ([app-atom]
   (fn [& args] (close-modal app-atom)))
  ([app-atom f]
   (fn [& args]
     (close-modal app-atom)
     (when f (apply f args)))))

(defn modal-open? [app-atom]
  (:open @(modal-cursor app-atom)))

(defn modal-key [app-atom]
  (let [modal-atom (modal-cursor app-atom)]
    (when (:open @modal-atom) (:type @modal-atom))))

;; ========= Confirmation Modal ===========================
(rum/defc modal-confirm-body [app-atom title body]
  [:div
   [:h3.modal__heading {:class (yuc/bem :heading [:medium-large])} title]
   body])

(rum/defc modal-confirm-text < rum/reactive [app-atom]
  (let [config (:config (rum/react (modal-cursor app-atom)))]
    (modal-confirm-body app-atom (:title config) (:text config))))

(rum/defc modal-confirm-footer < rum/reactive [app-atom]
  (let [{:keys [cancel-fn confirm-fn] :as config} (:config (rum/react (modal-cursor app-atom)))]
    (button-row
      {:left-text (or (:cancel-text config) "Back")
       :left-no-icon true
       :left-fn
       (cond
         cancel-fn
         #(do
            (cancel-fn app-atom)
            (close-modal app-atom))

         (:cancel-key config)
         #(dispatch-modal-action app-atom (:cancel-key config))

         :else
         #(close-modal app-atom))
       :right-text (or (:confirm-text config) "Confirm")
       :right-style (when (:negative config) :negative)
       :right-icon (or (:icon-left config) (:icon-right config))
       :right-icon-placement-left (when (:icon-left config) true)
       :right-no-icon (when-not (and (:icon-left config) (:icon-right config)) true)
       :right-fn
       (cond
         confirm-fn
         #(do
            (close-modal app-atom)
            (confirm-fn app-atom))

         (:confirm-key config)
         #(dispatch-modal-action app-atom (:confirm-key config) (or (:confirm-data config) {}))

         :else
         #(close-modal app-atom))})))

(defmethod modal-config :grid/confirm [app-atom config _]
  {:body modal-confirm-text
   :footer modal-confirm-footer
   :modal-type :alert})

(defn confirm-modal [app-atom {:keys [cancel-key confirm-key] :as config}]
  (open-modal app-atom :grid/confirm config))

;; ========= Message Modal ===========================
(rum/defc modal-message-footer < rum/reactive [app-atom]
  (let [config (:config (rum/react (modal-cursor app-atom)))]
    (button-row
      {:single-text (or (:confirm-text config) "Confirm")
       :single-style
       (if (:negative config)
         :negative
         :primary)
       :single-icon-left (:icon-left config)
       :single-fn
       (if (:confirm-key config)
         #(dispatch-modal-action app-atom (:confirm-key config))
         #(close-modal app-atom))})))

(defmethod modal-config :grid/message [app-atom config _]
  {:body modal-confirm-text
   :footer modal-message-footer
   :modal-type (or (:modal-type config) :alert)})

(defn message-modal [app-atom {:keys [confirm-key] :as config}]
  (open-modal app-atom :grid/message config))

(defmethod action :close-modal [app-atom]
  (close-modal app-atom))

;; ========= Editor Modal ===========================

(rum/defc modal-editor-footer-button < rum/reactive [app-atom idx editor button config]
  (let [on-click
        (cond
          (:action button)
          #(dispatch-modal-action app-atom (:action button)
             (merge {:editor-name editor} (:config button))
             {:prevent-closing (or (:prevent-closing config) true)})

          (:grid-action button)
          #(dispatch-action app-atom (:grid-action button) (merge {:editor-name editor} (:config button))))]
    [:div
     {:class (yuc/bem :flex-grid-block [:t-order-02 :t-1-2 :flush])}
     [:div.flex-grid-content
      (buttons/button-web (:text button)
        (yuc/maybe
          merge
          (or (:style button)
            {:style (if (= idx 0) :secondary-noborder :primary)
             :size :large
             :full true
             :persistent true
             :flat-style :flat
             :on-click on-click})
          {:on-click (fn [] on-click)}))]]))

(rum/defc modal-editor-footer < rum/reactive [app-atom config-atom]
  (let [{:keys [editor buttons editor-fns] :as config} (:config @config-atom)
        {:keys [error] :as editor-cfg} (cmn/curact app-atom [:datatables :editor editor])]
    [:div
     {:class (yuc/bem :flex-grid-group [:flush])}
     (when (yuc/presence error)
       [:div
        {:class (yuc/bem :flex-grid-block [:t-order-02 :t-1-1 :flush])
         :style {:font-size "12px" :color "red" :text-align "right" :padding "7.5px" :font-weight "bold"}}
        error])
     (->>
       buttons
       (remove nil?)
       (reverse)
       (map-indexed
         (fn [idx button]
           (rum/with-key
             (modal-editor-footer-button app-atom idx editor button config)
             idx))))]))

;; ========= Menu Item Modal ===========================
(rum/defc modal-menu-body < rum/reactive [app-atom]
  (let [{:keys [items]} (cmn/curact (modal-cursor app-atom) :config)]
    (into
      [:ul.context-menu-list]
      (->>
        items
        (remove nil?)
        (map
          (fn [i]
            [:li.context-menu-list__item
             (buttons/button (:label i)
               (cond
                 (:action i)
                 #(dispatch-modal-action app-atom (:action i) (:config i))

                 (:grid-action i)
                 #(dispatch-action app-atom (:grid-action i) (:config i)))

               (or (:style i)
                 {:full true :large true :secondary true}))]))))))

(defmethod modal-config :grid/menu [app-atom config _]
  {:body modal-menu-body
   :modal-type :context-menu})

(defn menu-modal [app-atom {:keys [items] :as config}]
  (open-modal app-atom :grid/menu config))

(rum/defc list-modal-footer < rum/reactive [app-atom config-atom]
  (let [config (cmn/curact config-atom :config)]
    (button-row
      {:single-text (or (:cancel-text config) "Cancel")
       :single-style :secondary
       :single-fn
       #(dispatch-modal-action app-atom (or (:cancel-key config) :grid/single-input-modal-cancel))})))

(rum/defc modal-list-body < rum/reactive [app-atom]
  (let [{:keys [title heading] :as modal-config-value} (cmn/curact (modal-cursor app-atom) :config)]
    [[:div.section
      [:div.u-margin-top-24
       [:h2.u-text-center
        {:class (yuc/bem :heading [:standard])}
        title
        [:span.heading__subtext
         heading]]]]
     [(:list modal-config-value)]]))

(defmethod modal-config :grid/list [app-atom config _]
  {:body modal-list-body
   :footer list-modal-footer
   :modal-type :details})

(defn list-modal [app-atom config]
  (open-modal app-atom :grid/list config))

(rum/defc multi-input-modal-body < rum/reactive [app-atom config-atom]
  (let [config (cmn/curact config-atom :config)]
    [:div
     [:h3.u-text-center
      {:class (yuc/bem :heading [:medium-large])}
      (:title config)]
     (:text config)
     (map
       (fn [{:keys [field-text input-key input-type field-placeholder] :as cfg} idx]
         (rum/with-key
           (cond
             (= input-type :datetime)
             (datepicker/datepicker app-atom field-text "dd/mm/yyyy"
               [:modal :config input-key]
               {:datatype :date/dmy
                :disabled false})

             :else
             (forms/input field-text (or field-placeholder "")
               (rum/cursor config-atom input-key)
               (if (zero? idx)
                 {:type input-type :auto-focus (cmn/auto-focus? app-atom)}
                 {:type input-type})))
           input-key))
       (:inputs config)
       (range (count (:inputs config))))]))

;; ========= Single Input Modal ===========================
(rum/defc single-input-modal-body < rum/reactive [app-atom config-atom]
  (let [config (cmn/curact config-atom :config)]
    [:div
     [:h3
      {:class (yuc/bem :heading [:medium-large])}
      (:title config)]
     (when (yuc/presence (:text config))
       [:p (:text config)])

     (forms/input (:field-text config) (:field-placeholder config "")
       (rum/cursor config-atom (:input-key config))
       {:type (:input-type config) :auto-focus (cmn/auto-focus? app-atom)})]))

(rum/defc single-input-modal-footer < rum/reactive [app-atom config-atom]
  (let [config (cmn/curact config-atom :config)]
    (button-row
      {:left-text (or (:cancel-text config) "Cancel")
       :left-no-icon true
       :left-fn
       #(dispatch-modal-action app-atom (or (:cancel-key config) :grid/single-input-modal-cancel))
       :right-text (or (:save-text config) "Submit")
       :right-no-icon true
       :right-fn
       #(dispatch-modal-action app-atom (or (:save-key config) :grid/single-input-modal-save))})))

(defmethod modal-config :grid/single-input-modal [_ _ _]
  {:body single-input-modal-body
   :footer single-input-modal-footer
   :modal-type :alert})

(defmethod modal-config :grid/multi-input-modal [app-atom _ _]
  (let [cfg (cmn/curact (modal-cursor app-atom) :config)]
    {:body multi-input-modal-body
     :footer single-input-modal-footer
     :modal-type (or (get-in cfg [:config :multi-modal-type]) :details)}))

(defn multi-input-modal [app-atom {:keys [inputs modal-type] :as config}]
  (open-modal app-atom (or modal-type :grid/multi-input-modal)
    (reduce
      (fn [x {:keys [input-key initial-value]}]
        (assoc
          x
          input-key
          initial-value))
      {:config config}
      inputs)))

(defn single-input-modal
  [app-atom
   {:keys [title field-text initial-value cancel-text save-text save-key
           input-key input-type] :as config}]
  (open-modal app-atom :grid/single-input-modal
    (assoc {:config config} input-key initial-value)))

;; Demo component.
(defmethod action :grid/demo-close [app-atom _]
  (swap! app-atom assoc :confirmed false))

(defmethod action :grid/demo-confirm [app-atom _]
  (swap! app-atom assoc :confirmed true))

(rum/defcs grid-demo < rum/reactive (rum/local {} ::state) [s]
  (let [local-atom (::state s)
        state (rum/react local-atom)
        footer-modal
        #(confirm-modal
           local-atom
           {:title "Title goes here"
            :text [:p "This is some content"]
            :confirm-text "Add to Cart" :confirm-key :grid/demo-confirm
            :cancel-text "Deliver" :cancel-key :grid/demo-close})]

    [:div.layout-component-demo
     (section
       (row {}
         (cell {:span 2 :cols 2} [:div.demo "Column 1/2"])
         (cell {:span 1 :cols 2} [:div.demo "Column 1/2"])
         (cell {:span 1 :cols 2} [:div.demo "Column 1/2"]))
       (row {}
         (cell {:span 3 :cols 3}
           [:div.demo
            [:a
             {:on-click footer-modal}
             "Open Confirm Modal"]
            (when (:confirmed state)
              (str " - Result: " (:confirmed state)))]))

       (row {}
         (cell {:span 3 :cols 3}
           [:div.demo
            [:a
             {:on-click
              #(menu-modal local-atom
                 {:items
                  [{:label "Confirm" :action :grid/demo-confirm}
                   {:label "Close" :action :grid/demo-close}]})}
             "Open Menu Modal"]
            (when (:confirmed state)
              (str " - Result: " (:confirmed state)))]))

       (row {}
         (cell {:span 2 :cols 3} [:div.demo "Column 2/3"])
         (cell {:span 1 :cols 3}
           [:div.demo
            "Column 1/3 that is particularly long in order to check the wrap"]))
       (row {}
         (cell {:span 1 :cols 3}
           [:div.demo "Column 1/3"])

         (cell {:span 2 :cols 3}
           [:div.demo
            "Column 2/3 that is particularly long in order to check the wrap"]))
       (row {}
         (cell {:span 1 :cols 4} [:div.demo "Column 1/4"])
         (cell {:span 2 :cols 4}
           [:div.demo
            "Column 2/4 that is particularly long in order to check the wrap"])
         (cell {:span 1 :cols 2} [:div.demo "Column 1/4"]))
       (row {}
         (cell {:span 1 :cols 4} [:div.demo "Column 1/4"])
         (cell {:span 3 :cols 4}
           [:div.demo
            "Column 3/4 that is particularly long in order to check the wrap"])))

     (modal-background local-atom)
     (modal local-atom false)
     (modal local-atom true)]))

(def barcode-icon
  [:div
   [:i.u-block-center
    {:class
     (yuc/bem
       :icon
       [:2-1 :barcode-scan :light-force :enormous :block])}]])
